// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1JXvv","sidebar_space":"Home_sidebar_space__2OxFh","sidebar_space--opened":"Home_sidebar_space--opened__zOdtd","button":"Home_button__wQdtp"};